import React from 'react'
import { useFormContext } from 'react-hook-form'
import useSessionStorage from '../../hooks/useSessionStorage'
import { initialFields } from '../../consts'

export default function Portal({ title, label, required = false }) {
  const {
    register,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext()

  const [storageData, setStorageData] = useSessionStorage(
    'app_data',
    initialFields
  )

  const handleChange = () => {
    setStorageData(getValues())
  }

  return (
    <div className="form-field">
      {title && <span>{title}</span>}
      <div className="form-group">
        <label htmlFor="MCCPERSTAG.TOMADOR.Portal">{label || 'Portal'}</label>
        <input
          id="MCCPERSTAG.TOMADOR.NumVia"
          className={`form-control${
            errors?.MCCPERSTAG?.TOMADOR?.Portal ? ' hasError' : ''
          }`}
          type="text"
          {...register('MCCPERSTAG.TOMADOR.Portal', {
            onChange: handleChange,
            required: required === true ? 'El Portal es obligatorio.' : false,
            pattern: {
              value: /^[A-Za-z0-9-]*$/i,
              message: 'Has introducido caracteres no permitidos.',
            },
            maxLength: {
              value: 10,
              message: 'El Bloque es demasiado largo.',
            },
          })}
        />
      </div>

      {errors?.MCCPERSTAG?.TOMADOR?.Portal && (
        <div className="error">
          <p>{errors.MCCPERSTAG.TOMADOR.Portal.message}</p>
        </div>
      )}
    </div>
  )
}
